'use strict';

/* global $ */

function FlexLink (options) {
    let opt = $.extend({
        linkSelector: 'a[data-flexlink]',
    }, options);

    function InitLink (link) {
        let url = $(link).data('flexlink');
        if (url) $(link).attr('href', url);
    }

    $(opt.linkSelector).each(function() {
        InitLink(this);
    });
}


export {
    FlexLink
};